export default __webpack_public_path__ + "static/media/delete-row-button.c64d913c.svg";